import { ActivitiesDefaultLimit } from '../types';

export const DefaultActivitiesAndNotificationsFilters = {
  limit: ActivitiesDefaultLimit,
  events: [],
  offers: [],
  talentPools: [],
  startDate: '',
  endDate: '',
  cursorPosition: null,
  cursorOrder: 'desc',
};
